import { GroupRoleName, RoleName } from "./role-name";

export type RoleNameMap = {
    [key in RoleName]: string;
};

export type GroupRoleNameMap = {
    [key in GroupRoleName]: string;
};